import { Link } from "react-router-dom";

const services = [
  {
    title: "Persianas",
    subtitle: "Reparación, cintas, lamas y motorización",
    badge: "Urgencias 24h",
    path: "/servicios/persianas",
    image: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/5f3786fc75d884aa1ab260fc93017308.webp",
    alt: "Reparación de persianas en Málaga — cambio de cintas, lamas y motorización por técnico especialista local",
  },
  {
    title: "Mosquiteras",
    subtitle: "A medida · Enrollables, fijas y correderas",
    badge: "A medida",
    path: "/servicios/mosquiteras",
    image: "/images/005-servicio-mosquiteras-card-v3.webp",
    alt: "Instalación de mosquiteras a medida en Málaga — enrollables, fijas y correderas para ventanas y puertas",
  },
  {
    title: "Motorización",
    subtitle: "Automatización sin obras · Motores Somfy y Nice",
    badge: "Motores Somfy",
    path: "/servicios/motorizacion",
    image: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/5634ceb95f45bd2fc3638e30354775c7.webp",
    alt: "Motorización de persianas en Málaga — automatización sin obras con motores Somfy y Nice, control por mando",
  },
];

export default function ServicesSection() {
  return (
    <section className="py-8 md:py-20 bg-gradient-to-br from-background-100 via-primary-50/20 to-accent-50/20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 md:gap-4 mb-6 md:mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">Nuestros servicios de persianas en Málaga</h2>
          <Link to="/contacto" className="text-sm md:text-base text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer">
            Pide presupuesto gratis →
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {services.map((s) => (
            <Link
              key={s.path}
              to={s.path}
              className="group relative h-56 sm:h-72 md:h-80 rounded-2xl overflow-hidden cursor-pointer"
            >
              <img
                alt={s.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
                src={s.image}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-secondary-900/70 via-secondary-900/10 to-transparent" />
              <span className="absolute top-3 right-3 md:top-4 md:right-4 bg-primary-500/90 backdrop-blur-sm text-background-50 text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap">
                {s.badge}
              </span>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <h3 className="text-base md:text-xl font-bold text-white font-heading">{s.title}</h3>
                <p className="text-xs md:text-sm text-white/80 mt-1">{s.subtitle}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}